import "../../styles/screens/services.scss";
import managerIcon from "../../assets/images/Icons/managerIcon.png";
import managerImg from "../../assets/images/Images/managerImg.png";
import AOS from "aos";
import "aos/dist/aos.css";
import de from "../../assets/texts/de.json";
import sr from "../../assets/texts/sr.json";
import { useLanguage } from "../../i18n/LanguageContext";

const ServiceFourth = () => {
  AOS.init({ duration: 2000 });
  const { language } = useLanguage();
  const t = language === "sr" ? sr.servicePages.fourth : de.servicePages.fourth;
  return (
    <div className="service-fourth">
      <div className="service-title" data-aos="fade-down">
        <h1 className="title">{t.title}</h1>
        <img className="manager" src={managerIcon} alt="Manager"></img>
      </div>
      <div className="divider"></div>
      <div className="content">
        <ul className="points">
          <li
            className="subtitle-first"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="100"
          >
            {t.points[0]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="400"
          >
            {t.points[1]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="700"
          >
            {t.points[2]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1000"
          >
            {t.points[3]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1300"
          >
            {t.points[4]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1600"
          >
            {t.points[5]}
          </li>
        </ul>
        <div className="image-container">
          <img src={managerImg} alt="Manager" />
        </div>
      </div>
    </div>
  );
};

export default ServiceFourth;
